// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7991037a","884":"6f2b7de5"}[chunkId] + ".chunk.js";
};